import {
  ApolloClient, InMemoryCache, gql, from
} from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';

import authLink from './authLink';
// eslint-disable-next-line import/no-cycle
import errorLink from './errorLink';
import publicLink from './publicLink';

const httpLink = createUploadLink({
  uri: process.env.GATSBY_API_URL,
  headers: { 'apollo-require-preflight': 'true' },
});

const link = from([
  errorLink,
  authLink,
  publicLink,
  httpLink
]);

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache'
  },
  query: {
    fetchPolicy: 'no-cache'
  }
};

class API {
  constructor() {
    this.client = new ApolloClient({
      link,
      cache: new InMemoryCache({
        addTypename: false
      }),
      defaultOptions
    });
  }

  graphql(strQuery, variables = {}, context = {}) {
    const isQuery = strQuery.indexOf('query ') !== -1;

    if (isQuery) {
      return this.client.query({
        query: gql(strQuery),
        variables,
        context
      });
    }
    return this.client.mutate({
      mutation: gql(strQuery),
      variables,
      context
    });
  }
}

const api = new API();
export default api;
